import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cx-surfacelog-metrics" }
const _hoisted_2 = { class: "cx-surfacelog-metrics__content__volumes__container" }
const _hoisted_3 = { class: "container-top" }
const _hoisted_4 = { class: "chart-column" }
const _hoisted_5 = { class: "grid-item chart-volume" }
const _hoisted_6 = { class: "volume__title" }
const _hoisted_7 = { class: "chart-column" }
const _hoisted_8 = { class: "grid-item chart-volume" }
const _hoisted_9 = { class: "volume__title" }
const _hoisted_10 = { class: "container-bottom" }
const _hoisted_11 = { class: "volume__title" }

import { ref, Ref, computed } from 'vue';
import CxPieChart from '../refmodel/components/pieChart/CxPieChart.vue';
import CxDisplayNumber from '../refmodel/components/CxDisplayNumber.vue';
import CxMetricsPanel from '../refmodel/CxMetricsPanel.vue';
import { gettext } from '@/translations/gettext.setup';


export default /*#__PURE__*/_defineComponent({
  __name: 'CxSurfacelogMetrics',
  props: {
  metricsData: { type: Object, required: true },
  title: { type: String, required: true },
  pow: { type: Number, required: true }
},
  setup(__props) {

const props = __props;

const { $gettext } = gettext;

const maxCharactersNumber: Ref<number> = ref(14);



const translations = computed(() => {
  return {
    cut: $gettext('Cut'),
    fill: $gettext('Fill'),
    remaining: $gettext('Remaining'),
  };
});

const downsizeFont = computed(() => {
  const maxCutFillDigits = Math.max(
    Math.round(props.metricsData.kpiData.fill).toString().length,
    Math.round(props.metricsData.kpiData.cut).toString().length
  );
  const remainingDigits = Math.round(props.metricsData.kpiData.remaining).toString().length;
  if (maxCutFillDigits + remainingDigits > maxCharactersNumber.value) return true;
  return false;
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CxMetricsPanel, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(CxPieChart, {
                plotData: __props.metricsData.chartData,
                seriesClass: "series__cut",
                type: "cut"
              }, null, 8, ["plotData"]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(translations.value.cut), 1)
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(CxDisplayNumber, {
                  value: __props.metricsData.kpiData.cut,
                  pow: props.pow,
                  className: {'volume__volume': true, 'volume__volume--cut': true, 'downsize-font': downsizeFont.value}
                }, null, 8, ["value", "pow", "className"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(CxPieChart, {
                plotData: __props.metricsData.chartData,
                seriesClass: "series__fill",
                type: "fill"
              }, null, 8, ["plotData"]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(translations.value.fill), 1)
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(CxDisplayNumber, {
                  value: __props.metricsData.kpiData.fill,
                  pow: props.pow,
                  className: {'volume__volume': true, 'volume__volume--fill': true, 'downsize-font': downsizeFont.value}
                }, null, 8, ["value", "pow", "className"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(_toDisplayString(translations.value.remaining), 1)
              ])), [
                [_directive_translate]
              ]),
              _createVNode(CxDisplayNumber, {
                value: __props.metricsData.kpiData.remaining,
                pow: props.pow,
                className: {'volume__volume': true, 'downsize-font': downsizeFont.value}
              }, null, 8, ["value", "pow", "className"])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})